import { useContext } from 'react';
import { useGetCompany } from '../../../../api/company';
import { WorkOrderContext } from '../context/WorkOrderContext';

export default function StoreInformation() {

	const { order } = useContext(WorkOrderContext);

	const store = useGetCompany(order.details.dealerCompanyID);

	return (
		<span className='store-information'>
			{store.data?.companyName}, {store.data?.PA_Address1}{!!store.data?.PA_Address2 && ' ' + store.data?.PA_Address2}, {store.data?.companyCode}
		</span>
	);
}
